import orderBy from "lodash/orderBy";
import uniqBy from "lodash/uniqBy";

const RECENT_TEMPLATE_DISPLAY_COUNT = 3; // number of recent templates to display

export default function computeRecommendedTemplates(
	defaultTeamTypeSuggestedTemplates,
	teamTypeSuggestedTemplates,
	teamSpaceCustomTemplates
) {
	// 1. never more than three (for now)
	// 2. start with a default set of our top three recommended for either a
	//    1:1 or team, depending on which type of space it is
	// 3. once a user starts using templates, we could favor recently used to
	//    fill the three slots
	// 4. if a user creates a custom template, we would favor that above any
	//    other recently used templates

	let recommendedTemplates = [
		...defaultTeamTypeSuggestedTemplates, // already sorted
	];

	//
	// Find recently used templates, if any
	//
	const allUsedTemplates = [
		...teamSpaceCustomTemplates,
		...teamTypeSuggestedTemplates,
	].filter( template => !!template.lastAdded )
		.map( template => {
			return {
				...template,
				sortKey: template.lastAddedAt,
				isRecentlyUsed: true,
			};
		} );
	const sortedUsedTemplates = orderBy( allUsedTemplates, [ "sortKey", ], [ "desc", ] );

	//
	// Find any custom templates that were created *after* the most
	// recently used template
	//
	if ( sortedUsedTemplates.length ) {
		const { sortKey: lastTemplateUsedAt, } = sortedUsedTemplates[ 0 ];
		const newerTemplates = teamSpaceCustomTemplates
			.filter( template => template.createdAt > lastTemplateUsedAt )
			.map( template => {
				return {
					...template,
					sortKey: template.createdAt,
					isRecentlyUsed: false,
				};
			} );
		const sortedNewerTemplates = orderBy( newerTemplates, [ "sortKey", ], [ "desc", ] );
		recommendedTemplates = [
			...sortedNewerTemplates,
			...sortedUsedTemplates,
			...recommendedTemplates,
		];
	}

	return uniqBy( recommendedTemplates, "meetingTemplateId" )
		.slice( 0, RECENT_TEMPLATE_DISPLAY_COUNT );
}
